import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import {
  HOUR_MINUTE_DAY_TIME,
  MILITARY_TIME
} from 'bento-ordering/base/constants/timeFormat';
import MenuItemDescriptionTypography from 'components/MenuItemDescriptionTypography';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';

const NO_HOURS_MESSAGE = 'Currently Unavailable';

function HoursDay({ label, hours, adornmentEnd, dataTestId }) {
  const formattedHours = (hours || []).map((hours, idx, arr) => (
    <ListItem
      role="listitem"
      key={`${label}-${hours.open_time}-${hours.close_time}-${idx}`}
    >
      <MenuItemDescriptionTypography
        variant={ITEM_DESCRIPTION_AND_PRICES}
        sx={{ lineHeight: 1.3 }}
      >
        {moment(hours.open_time, MILITARY_TIME).format(HOUR_MINUTE_DAY_TIME)} -{' '}
        {moment(hours.close_time, MILITARY_TIME).format(HOUR_MINUTE_DAY_TIME)}
        {idx === arr.length - 1 && adornmentEnd}
      </MenuItemDescriptionTypography>
    </ListItem>
  ));

  return (
    <div data-testid={dataTestId}>
      {formattedHours.length ? (
        <div>
          <MenuItemDescriptionTypography
            variant={ITEM_DESCRIPTION_AND_PRICES}
            sx={{ lineHeight: 1.3 }}
            component="span"
          >
            {label}
          </MenuItemDescriptionTypography>
          : <List>{formattedHours}</List>
        </div>
      ) : (
        <MenuItemDescriptionTypography variant={ITEM_DESCRIPTION_AND_PRICES}>
          {`${label}: ${NO_HOURS_MESSAGE}`}{' '}
        </MenuItemDescriptionTypography>
      )}
    </div>
  );
}

HoursDay.defaultProps = {
  hours: [],
  dataTestId: ''
};

HoursDay.propTypes = {
  label: PropTypes.string,
  dataTestId: PropTypes.string,
  adornmentEnd: PropTypes.element,
  hours: PropTypes.arrayOf(
    PropTypes.shape({
      open_time: PropTypes.string,
      close_time: PropTypes.string
    })
  )
};

export default HoursDay;
